// Raw Material Mutations

export const setFullRawMaterialsList = (state, payload) => {
  state.fullRawMaterialsList = payload
}

export const updateRawMaterialsList = (state, payload) => {
  state.rawMaterialsList = payload
}

export const fetchRawMaterialInfo = (state, payload) => {
  state.rawMaterialInfo = payload
}
